import React from 'react';
import { useSelector } from "react-redux";
import { Row, Col, Divider } from 'antd';
import DataFilter from './DataFilter';
import RealTimeRange from 'components/Common/DateRangeComponents/RealTimeRange';
import LastUpdatedStatus from 'components/Common/LastUpdatedStatus';

const Toolbar = ({ 
  queryFieldsChange,
  changeDateRange,
}) => {

  const pageLastUpdatedTime = useSelector((state) => state.loader)?.pageLastUpdatedTime;

  return (
    <div style={styles.toolbar}>
      <Row align="middle" justify="space-between" gutter={[16, 16]}>
        {/* Data Section */}
        <Col xs={24} md={12} lg={4} xl={4} style={{ alignItems: 'left',
      fontWeight: 'bold',
      fontSize: '18px',
      padding: '0 8px',}}>
                <span>
                      { `Realtime Data`}</span>
               </Col>
        <Col xs={24} md={12} lg={8} xl={9} style={styles.section}>
            <div className='w100'>
            <DataFilter 
              queryFieldsChange={queryFieldsChange}
              // style={{width: '200px'}}
            />
          </div>
        </Col>
        <Divider type="vertical" style={{ height: '50px',
      borderColor: "#c2c1c1"}} className='hide-max-md' />
        <Col xs={24} md={{offset: 12, span:12 }} lg={{offset: 0, span:6}} xl={5}>
          <RealTimeRange
            showText={false}
            onTimeFilterChange={changeDateRange}
          />  
        </Col>
        <Divider type="vertical" style={{ height: '50px',
      borderColor: "#c2c1c1"}} className='hide-max-md' />
        <Col xs={0} md={0} lg={5} xl={4} className='display-flex hide-max-md'>
          <LastUpdatedStatus
            showTime={"time-left"}
            lastUpdatedTime={pageLastUpdatedTime}
          />
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 12px',
  },
  sectionTitle: {
    alignItems: 'center',
    fontWeight: 'bold',
    marginBottom: 8,
  },
  iconGroup: {
    display: 'flex',
    gap: '32px',
  },
  icon: {
    fontSize: '24px',
    cursor: 'pointer',
  },
  divider: {
    height: '50px',
    borderColor: "#c2c1c1"
  },
};

export default Toolbar;
